import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import moment from "moment";
import { API_PATHS } from "../../utils/apiPaths";
import { BsCalendar2Date } from "react-icons/bs";
import { GiSandsOfTime } from "react-icons/gi";
import "moment/locale/fr";
import TaskCard from "../../components/Cards/TaskCard";
moment.locale("fr");

const ProjectDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [project, setProject] = useState(null);
  const [allTasks, setTasks] = useState([]);

  const fetchProjectsById = async (id) => {
    try {
      const response = await axiosInstance.get(API_PATHS.PROJECT.GET_ALL_BY_ID(id));
      setProject(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération du projet :", error);
    }
  };

  const fetchTasksByProjectId = async (id) => {
    try {
      const response = await axiosInstance.get(API_PATHS.TASKS.GET_TASK_BY_PROJECT(id));

      setTasks(Array.isArray(response.data?.tasks) ? response.data.tasks : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des tâches :", error);
      setTasks([]); // sécurité
    }
  };

  const handleClick = (taskData) => {
    navigate("/admin/tasks", { state: { taskId: taskData._id } });
  };

  useEffect(() => {
    if (id) {
      fetchProjectsById(id);
      fetchTasksByProjectId(id);
    }
  }, [id]);

  return (
    <DashboardLayout>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Détails du projet</h1>
      <div className="bg-gradient-to-r from-white to-blue-50 shadow-lg rounded-3xl p-8 mb-6 border border-gray-200 mt-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-3xl font-bold text-gray-900 truncate">
            {project?.name || "Nom du projet"}
          </h1>
          <div className="bg-blue-100 p-3 rounded-full shadow-inner">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 7.5A2.25 2.25 0 015.25 5.25h3.378a2.25 2.25 0 011.59.659l.707.707a2.25 2.25 0 001.59.659h5.484A2.25 2.25 0 0120.25 9.75v8.25A2.25 2.25 0 0118 20.25H6a2.25 2.25 0 01-2.25-2.25V7.5z"
              />
            </svg>
          </div>
        </div>

        <p className="text-gray-700 mb-5 text-base md:text-lg leading-relaxed">
          {project?.description || "Aucune description disponible."}
        </p>

        <div className="flex flex-wrap items-center text-sm md:text-base text-gray-600 gap-6">
          <div className="flex items-center gap-2">
            <span className="text-blue-500 text-lg"><BsCalendar2Date /></span>
            <span>
              <strong>Début :</strong>{" "}
              {project?.startDate
                ? moment(project.startDate).format("Do MMM YYYY")
                : "-"}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-green-500 text-lg"><GiSandsOfTime /></span>
            <span>
              <strong>Fin :</strong>{" "}
              {project?.endDate
                ? moment(project.endDate).format("Do MMM YYYY")
                : "-"}
            </span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        {Array.isArray(allTasks) && allTasks.length > 0 ? (
          allTasks.map((item) => (
            <TaskCard
              key={item._id}
              title={item.title}
              description={item.description}
              priority={item.priority}
              status={item.status}
              progress={item.progress}
              createdAt={item.createdAt}
              dueDate={item.dueDate}
              assignedTo={
                item.assignedTo?.map((user) => user.profileImageUrl) || []
              }
              attachmentCount={item.attachments?.length || 0}
              completedTodoCount={item.completedTodoCount || 0}
              todoCheckList={item.todoCheckList || []}
              onClick={() => handleClick(item)}
            />
          ))
        ) : (
          <p className="text-gray-500 text-sm italic col-span-full">
            Aucune tâche trouvée pour ce projet.
          </p>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ProjectDetails;
